import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import StartTheConnection from "./sections/StartTheConnection";
import GlobalPresence from "./sections/GlobalPresence";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <StartTheConnection />
      <GlobalPresence />
      <Footer />
    </div>;
}